export default __webpack_public_path__ + "static/media/about.74cfa393.jpg";